import { logoutUser } from '../helpers/Auth';
import redirect from '../helpers/RedirectToExternalPage';

const useLogout = () => {
  return () => {
    logoutUser();
    redirect(process.env.SSO_URL);
  };
};

export default useLogout;
